import { render } from "./NewsList.vue?vue&type=template&id=3d2bc822"
import script from "./NewsList.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsList.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/codebuild/output/src3003388635/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/portal-dev-frontend/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/components/templates/news/NewsList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3d2bc822"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3d2bc822', __exports__)) {
    console.log('reload')
    api.reload('3d2bc822', __exports__)
  }
  
  module.hot.accept("./NewsList.vue?vue&type=template&id=3d2bc822", () => {
    console.log('re-render')
    api.rerender('3d2bc822', render)
  })

}


export default __exports__